import React from 'react';
const Footer = () => {
    return (
      <footer style={{textAlign: "center"}} className="app-footer">
        <p style={{margin: "auto"}}>Copyright UnoHR &copy; 2019</p>
      </footer>
    );
  }
;

export default Footer;
